import * as Sentry from '@sentry/react-native';
import { useEffect } from 'react';
import ResponsiveTabNavigator from '@/components/Navigation/ResponsiveTabNavigator';
import useCurrentUser from '@/hooks/useCurrentUser';
import useGlobalSubscriptions from '@/hooks/useGlobalSubscriptions';
import { useRegisterPushToken } from '@/hooks/useInitializePush';
import useSyncNotificationBadgeOnActive from '@/hooks/useSyncNotificationBadgeOnActive';
import useUnseenMessageCount from '@/hooks/useUnseenMessageCount';

export const unstable_settings = {
  initialRouteName: 'event',
};

export default function PrivateTabsLayoutRoute() {
  const unseenMessageCount = useUnseenMessageCount();
  useGlobalSubscriptions();
  const user = useCurrentUser();
  useRegisterPushToken(!!user?.is_complete);
  useSyncNotificationBadgeOnActive();

  useEffect(() => {
    Sentry.setContext('user', {
      id: user?.id,
      username: user?.username,
    });
  }, [user]);

  return (
    <ResponsiveTabNavigator unseenMessageCount={unseenMessageCount || null} />
  );
}
